module.exports = __webpack_public_path__ + "images/4168bd5c89d3105c6816018985e2f19a-illu_dir_recessed2.png";